export default __webpack_public_path__ + "static/3-de7a0ae3f937ad5b8f13f49c64355740.jpg";